import { Link, Navigate, useParams } from 'react-router-dom';
import { Button, CheckIcon } from '../../../components';
import { useTodoTasks, useResolverUrl } from '../utils/hooks';
import successCloudImage from '../../../assets/success-cloud.svg';
import smallCloudImage from '../../../assets/small-cloud.svg';
import { getStateSealImage } from '../../../utils/seals';
import { USStateAbbrev } from '../../../constants';
import { LOCATION_CODE_TO_NAME } from '../../../utils/locations';

const StateSetupComplete = () => {
  const { locationId } = useParams();

  if (!locationId) {
    return <Navigate to="/tasks/resolver/complete" replace />;
  }

  const name = LOCATION_CODE_TO_NAME[locationId.toUpperCase()];

  return (
    <div className="flex flex-col items-center space-y-6">
      <div className="relative">
        <img className="w-96" src={successCloudImage} alt="" />

        <div className="absolute right-28 top-24 z-20 -translate-x-2 -translate-y-2 rounded-full border border-lime-500 bg-lime-500 p-1 text-white">
          <div className="size-5">
            <CheckIcon />
          </div>
        </div>

        <img
          className="absolute left-1/2 top-1/2 size-36 -translate-x-1/2 -translate-y-1/2"
          src={getStateSealImage(locationId as USStateAbbrev)}
          alt={`${name} state seal`}
        />

        <img
          className="absolute right-20 top-24 w-16 -translate-y-2 translate-x-6"
          src={smallCloudImage}
          alt=""
        />

        <img
          className="absolute bottom-24 left-20 w-16 -translate-x-2 translate-y-4"
          src={smallCloudImage}
          alt=""
        />
      </div>

      <div className="max-w-xl space-y-6 text-center">
        <h1 className="text-5xl font-black">Great Job!</h1>
        <p className="text-lg font-medium">You completed setting up {name}.</p>
      </div>

      <Button size="xlarge" as={Link} to={`/locations/usa/${locationId}`}>
        View Your {name} Dashboard
      </Button>
    </div>
  );
};

const GenericComplete = () => {
  return (
    <div className="flex flex-col items-center space-y-6">
      <div className="relative">
        <img className="w-96" src={successCloudImage} alt="" />

        <div className="absolute left-1/2 top-1/2 size-36 -translate-x-1/2 -translate-y-1/2 rounded-full bg-lime-500 text-white">
          <CheckIcon strokeWidth={3} />
        </div>

        <img
          className="absolute right-20 top-24 w-16 -translate-y-2 translate-x-6"
          src={smallCloudImage}
          alt=""
        />

        <img
          className="absolute bottom-24 left-20 w-16 -translate-x-2 translate-y-4"
          src={smallCloudImage}
          alt=""
        />
      </div>

      <div className="max-w-xl space-y-6 text-center">
        <h1 className="text-5xl font-black">Great Job!</h1>
        <p className="text-lg font-medium">
          All outstanding tasks have been completed.
        </p>
      </div>

      <Button size="xlarge" as={Link} to="/home">
        Go Home
      </Button>
    </div>
  );
};

export const ResolverComplete = () => {
  const { resolverType } = useParams();
  const todoTasks = useTodoTasks();
  const resolverUrl = useResolverUrl();

  if (todoTasks.length > 0) {
    return <Navigate to={resolverUrl} replace />;
  }

  return (
    <div className="h-[calc(100vh-64px)] p-6">
      <div className="flex h-full items-center justify-center border bg-white">
        <div className="size-full overflow-y-auto p-6">
          {resolverType === 'setup' ? (
            <StateSetupComplete />
          ) : (
            <GenericComplete />
          )}
        </div>
      </div>
    </div>
  );
};
